import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

const PolicyLinks = ({ isApp = false, devices }) => {
    const limitAccessFireTv = devices?.limitAccessFireTv;

    return (
        <>
            {isApp ? (
                <div align="center" style={{ marginBottom: "20px" }}>
                    <div>
                        <Link to="/login">Back To Login</Link>
                    </div>
                </div>
            ) : (
                <div align="center" style={{ marginBottom: "20px" }}>
                    {!limitAccessFireTv && (
                        <div>
                            <Link to="/">Home</Link>
                        </div>
                    )}
                    <div>
                        <Link to="/terms">Terms & Conditions</Link>
                    </div>
                    <div>
                        <Link to="/privacy-policy">Privacy Policy</Link>
                    </div>
                    <div>
                        <Link to="/cookie-policy">Cookie Policy</Link>
                    </div>
                    <div>
                        <Link to="/data-protection">Data Protection</Link>
                    </div>
                    {/*<div>*/}
                    {/*    <Link to="/popup-terms">Popup Terms</Link>*/}
                    {/*</div>*/}
                </div>
            )}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        devices: state.devices,
    };
};

export default connect(mapStateToProps)(PolicyLinks);